<template>
  <div class="page">
    <div class="control">
      <el-form label-position="top" class="control-child-top" ref="form">
        <el-form-item label="协议开关:">
          <el-radio-group v-model="agreementSwitch">
            <el-radio :label="1">打开</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-form-item label="强制阅读配置:">
          <el-checkbox-group v-model="forceRead">
            <el-checkbox label="mobile">移动端</el-checkbox>
            <el-checkbox label="terminal">访客端</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-button class="control-child-bottom" @click="onSaveClick" type="primary" :disabled="!hasCommitPermission">保存</el-button>
    </div>
    <div class="editor">
      <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"/>
        <Editor
            style="height: 500px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"/>
      </div>
    </div>

  </div>
</template>

<script>

import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {getPublicSettingInfo, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "SettingAgreementItem",
  props: ['agreementType'],
  components: {Editor, Toolbar},
  data() {
    return {
      userAgreement: "userAgreement",
      secretAgreement: "secretAgreement",
      privacyAgreement: "privacyAgreement",
      visitorAgreement: "visitorAgreement",

      agreementSwitch: 0,
      forceRead: [],

      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple'

      isShow: false,
    }
  }, // data
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onSaveClick() {
      let params = this.agreementType
      let isOpen = this.agreementSwitch
      let agreementContent = this.html
      let readFlag = this.forceRead.join("|")
      const postData = {
        target: "ALL",
        type: params,
        content: agreementContent,
        state: isOpen === 1 ? "VALID" : "INVALID",
        readFlag: readFlag
      }

      setSystemSettingInfo(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          console.log("setAgreement false", data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log("getAgreement err", err)
        this.showNetErrMsg()
      })
    },
  }, // methods

  mounted() {
    this.isShow = true
    let params = this.agreementType
    if (params === "") {
      console.error("getAgreement api missing type " + this.agreementType)
      this.$message.error("未知协议类型")
      return
    }

    getPublicSettingInfo(params).then(({data}) => {
      console.log("getAgreement", data)
      if (data.code === 200) {
        if (data.data && data.data.length > 0) {
          this.agreementSwitch = data.data[0].state === 'VALID' ? 1 : 0
          this.html = data.data[0].content
          if (data.data[0].readFlag) {
            this.forceRead = data.data[0].readFlag.split("|")
          }
        } else {
          this.agreementSwitch = 0
        }

      } else {
        console.log("getAgreement false", data.msg)
        this.showServerErrMsg(data.msg)
      }
    }).catch(err => {
      console.log("getAgreement err", err)
      this.showNetErrMsg()
    })
  },

  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("SYSTEM_SETTING_MODIFY")
        default:
          return false
      }
    }
  },
}
</script>


<style scoped lang="less">

@import "../../../node_modules/@wangeditor/editor/dist/css/style.css";

.page {
  display: flex;

  .control {
    width: 200px;
    height: 540px;
    margin-right: 10px;

    border: 1px solid #cccccc;

    padding: 20px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .editor {
    flex: 1;
    height: 70vh;
  }
}

</style>
